import { useDispatch, useSelector } from "react-redux";
import { setModalsData, TModalsState } from "../../api/store/commonSlice";

const AppContextMenu = () => {
  const modalsState = useSelector(
    (state: { commonReducer: { modals: TModalsState } }) =>
      state.commonReducer.modals
  );
  const dispatch = useDispatch();

  if (!modalsState?.showContextMenu || !modalsState?.contextMenuOptions)
    return null;

  const { AnchorRef, Content, relativePosition, widthClass } =
    modalsState?.contextMenuOptions;

  let placementClass = "";
  switch (relativePosition) {
    case "bottom-left":
      placementClass = "bottom-0 right-full me-2";
      break;
    case "bottom-right":
      placementClass = "bottom-0 left-full ms-2";
      break;
    case "top-left":
      placementClass = "top-0 right-full me-2";
      break;
    case "top-right":
      placementClass = "top-0 left-full ms-2";
      break;
  }

  return (
    <>
      <div
        className="fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay"
        onClick={(e) => {
          e.stopPropagation();
          dispatch(
            setModalsData({
              ...modalsState,
              showContextMenu: false,
            })
          );
        }}
      />
      {/* reference div to render over the  */}
      <div
        className={`absolute`}
        // use the position of AnchorElement to position the context menu
        style={{
          top: (AnchorRef as HTMLElement)?.getBoundingClientRect().top || 0,
          left: (AnchorRef as HTMLElement)?.getBoundingClientRect().left || 0,
          width:
            (AnchorRef as HTMLElement)?.getBoundingClientRect().width || 40,
          height:
            (AnchorRef as HTMLElement)?.getBoundingClientRect().height || 40,
        }}
      >
        <div
          className={`absolute ${placementClass} z-modal bg-white shadow-md border rounded-md ${modalsState.contextMenuOptions.widthClass}`}
        >
          {modalsState.contextMenuOptions.Content}
        </div>
      </div>
    </>
  );
};
export default AppContextMenu;
